import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@/components/ui";
import Seo from "@/components/Seo";
import { ImmersiveShell } from "@/components/immersive/ImmersiveShell";
import { Reveal } from "@/components/immersive/Reveal";
import Breadcrumbs from "@/components/immersive/Breadcrumbs";
import { CtaCluster } from "@/components/immersive/MarketingBits";
import { MATCH_STEPS } from "@/lib/content";

const PARAS = [
  "Senior care matching helps families find the right in-home support for an older loved one without calling agency after agency. You share the needs and preferences once; we do the outreach.",
  "We reach out to our network of partner home-care agencies to check for an available caregiver who may be a good match based on care needs, schedule, location, language, and personal preferences. Submitted information is used to identify potential matches — placement is never guaranteed.",
];

export default function SeniorCareMatching() {
  return (
    <ImmersiveShell>
      <Seo title="Senior Care Matching" path="/senior-care-matching"
        description="Senior care matching with HomecareMatches — tell us your loved one's needs and we connect you with partner home-care agencies that may have available caregivers for in-home senior care."
        keywords="senior care matching, senior care, in-home care, caregiver matching, home care services" />
      <section className="imm-mkt-hero imm-wrap" data-testid="senior-care-matching">
        <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Senior Care Matching" }]} />
        <Reveal className="imm-eyebrow" delay={80}>Senior care matching</Reveal>
        <Reveal as="h1" delay={180}>Senior Care Matching</Reveal>
        {PARAS.map((p, i) => <Reveal key={i} as="p" delay={300 + i * 120}>{p}</Reveal>)}
      </section>

      <section className="imm-wrap" data-testid="scm-steps" style={{ paddingBottom: "6vh" }}>
        <Reveal as="h2" className="imm-svc-h2">How senior care matching works</Reveal>
        <div style={{ marginTop: 22 }}>
          {MATCH_STEPS.map((s, i) => (
            <Reveal key={i} delay={i * 60}><div className="imm-feature"><span className="fnum">{String(i + 1).padStart(2, "0")}</span><div><h3>{s.title}</h3><p>{s.desc}</p></div></div></Reveal>
          ))}
        </div>
        <Reveal delay={120}><p style={{ marginTop: 20 }}><Link className="imm-inline-link" to="/caregiver-matching">See how caregiver matching works <Icon name="arrow-right" size={15} /></Link></p></Reveal>
      </section>

      <section className="imm-wrap" data-testid="scm-cta" style={{ paddingBottom: "8vh" }}>
        <Reveal as="h2" className="imm-svc-h2">Get matched for senior care</Reveal>
        <Reveal delay={80}><div style={{ marginTop: 18 }}><CtaCluster showPromo /></div></Reveal>
      </section>
    </ImmersiveShell>
  );
}
